import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown, Gift, Flame, Check, ShieldCheck, ArrowRight, Zap, Clock } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex flex-col items-center justify-center pt-20 pb-12 px-4 overflow-hidden" data-id="element-66">
      {/* Background Image with Cinematic Scrim */}
      <div className="absolute inset-0 z-0" data-id="element-67">
        <img src="https://cdn.magicpatterns.com/uploads/w4tzeMYujDbs59SSCcUnmR/banner_asado.jpg" alt="Asado Chileno" className="w-full h-full object-cover object-center" data-id="element-68" />
        <div className="absolute inset-0 bg-gradient-to-b from-bbq-dark/80 via-bbq-dark/70 to-bbq-dark" data-id="element-69"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(13,11,10,0.8)_100%)]" data-id="element-70"></div>
      </div>

      {/* Header Logo */}
      <div className="absolute top-0 left-0 w-full p-6 z-20 flex justify-center" data-id="element-71"></div>

      {/* Content */}
      <div className="relative z-10 max-w-3xl mx-auto text-center mt-12" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-73">
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-display font-bold text-white leading-[1.05] tracking-tight uppercase mb-6 drop-shadow-2xl flex flex-col items-center gap-3" data-id="element-74">
            <Gift className="text-bbq-ember" size={48} aria-hidden="true" data-id="element-75" />
            <span data-id="element-76">
              El Regalo más <span className="text-bbq-ember" data-id="element-77">PRO</span> para el
              Día del Padre
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 font-medium mb-5 max-w-2xl mx-auto drop-shadow-lg" data-id="element-78">
            Dale a tu Papá el{' '}
            <strong className="text-bbq-gold font-semibold" data-id="element-79">
              Código Secreto del Asado Chileno
            </strong>{' '}
            — por menos de lo que gastas en una botella de vino de súper.
          </p>

          <p className="inline-flex items-center gap-2 text-base md:text-lg text-gray-300 font-medium mb-8 drop-shadow-lg" data-id="element-80">
            Sin filas. Sin despacho. Sin gastar de más. Llega a su email en 30
            segundos.
            <Flame className="text-bbq-ember shrink-0" size={20} aria-hidden="true" data-id="element-81" />
          </p>
        </motion.div>

        {/* Trust bullets */}
        <motion.ul initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="bg-bbq-surface/60 backdrop-blur-sm border border-white/10 p-5 md:p-6 rounded-xl max-w-xl mx-auto mb-8 space-y-3 text-left" data-id="element-82">
          <li className="flex items-start gap-3 text-gray-200" data-id="element-83">
            <span className="mt-0.5 shrink-0 bg-bbq-ember/20 text-bbq-ember rounded-full p-1" data-id="element-84">
              <Check size={16} aria-hidden="true" data-id="element-85" />
            </span>
            <span data-id="element-86">
              Regalo <strong className="text-white" data-id="element-87">DIGITAL</strong> — Lo
              imprimes tú y queda como regalo de{' '}
              <strong className="text-bbq-gold" data-id="element-88">$50.000</strong>.
            </span>
          </li>
          <li className="flex items-start gap-3 text-gray-200" data-id="element-89">
            <span className="mt-0.5 shrink-0 bg-bbq-ember/20 text-bbq-ember rounded-full p-1" data-id="element-90">
              <ShieldCheck size={16} aria-hidden="true" data-id="element-91" />
            </span>
            <span data-id="element-92">
              Garantía total de <strong className="text-white" data-id="element-93">7 días</strong> o
              te devolvemos cada peso.
            </span>
          </li>
        </motion.ul>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-94">
          <button onClick={scrollToOffer} className="w-full sm:w-auto bg-bbq-ember hover:bg-bbq-ember-dark text-white font-display uppercase tracking-wider py-4 px-8 md:px-10 rounded-sm transition-all duration-300 shadow-[0_0_30px_rgba(232,98,45,0.3)] hover:shadow-[0_0_40px_rgba(232,98,45,0.5)] transform hover:-translate-y-1 flex flex-col items-center gap-1 mx-auto" data-id="element-95">
            <span className="flex items-center gap-3 text-xl md:text-2xl" data-id="element-96">
              Quiero este regalo por $6.390
              <ArrowRight size={24} aria-hidden="true" data-id="element-97" />
            </span>
          </button>

          <p className="mt-3 inline-flex items-center gap-2 text-sm text-bbq-gold font-medium" data-id="element-98">
            <Zap size={16} className="shrink-0" aria-hidden="true" data-id="element-99" />
            Recíbelo en tu email en menos de 30 segundos
          </p>

          <p className="mt-2 flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-100">
            <Clock size={14} className="shrink-0" aria-hidden="true" data-id="element-101" />
            Quedan pocos días · Precio sube a $14.990 después del 19 de Junio
          </p>
        </motion.div>
      </div>

      <motion.div className="absolute bottom-8 text-white/50 animate-bounce cursor-pointer z-10" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} onClick={() => document.getElementById('hook')?.scrollIntoView({
      behavior: 'smooth'
    })} data-id="element-102">
        <ChevronDown size={32} data-id="element-103" />
      </motion.div>
    </section>;
}